import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { GrantService } from '../../../services/grant.service';
import { FilterFieldConfig } from '../filter.component';
import { GetGrantsFilter, Grant } from '../../../models/grant';
import { ProjectStatus } from '../../../enums/project-status';


@Injectable({
  providedIn: 'root'
})
export class ProjectsFilterBuilder {
  private fields: FilterFieldConfig[] = [];

  constructor(private grantService: GrantService) {}

    type(): ProjectsFilterBuilder {
      this.fields.push({
        name: 'type',
        label: 'Vrsta projekta',
        type: 'select',
        multiple: false,
        options: [
          { label: 'Izravna dodjela sredstava', value: 1 },
          { label: 'Prijava na natječaj', value: 2 }
        ],
        placeholder: 'Odaberite vrstu projekta'
      });
      return this;
    }

    status(): ProjectsFilterBuilder {
      this.fields.push({
        name: 'status',
        label: 'Status projekta',
        type: 'select',
        multiple: false,
        options: [
          { label: 'U pripremi', value: ProjectStatus.Preparation },
          { label: 'U provedbi', value: ProjectStatus.Started },
          { label: 'Završen',    value: ProjectStatus.Completed },
        ],
        placeholder: 'Odaberite status',
      });
      return this;
    }

  years(fromYear: number, yearsCount: number = 100): ProjectsFilterBuilder {
    const options = Array.from({ length: yearsCount }, (_, i) => ({
      label: (fromYear + i).toString(),
      value: fromYear + i
    }));

    this.fields.push({
      name: 'year',
      label: 'Godina',
      type: 'select',
      multiple: false,
      options,
      placeholder: 'Odaberite godinu',
      initialValue: fromYear
    });
    return this;
  }

  initialBudgetInSync(): ProjectsFilterBuilder {
    this.fields.push({
      name: 'isInitialBudgetInSyncFilter',
      label: 'Proračun usklađen',
      type: 'select',
      multiple: false,
      options: [
        { label: 'Da', value: true },
        { label: 'Ne', value: false }
      ],
      placeholder: 'Odaberite'
    });
    return this;
  }

   initialBudgetApproved(): ProjectsFilterBuilder {
    this.fields.push({
      name: 'isInitialBudgetApprovedFilter',
      label: 'Proračun odobren',
      type: 'select',
      multiple: false,
      options: [
        { label: 'Da', value: true },
        { label: 'Ne', value: false }
      ],
      placeholder: 'Odaberite'
    });
    return this;
  }

  reallocationBudgetsInSync(): ProjectsFilterBuilder {
    this.fields.push({
      name: 'areReallocationBudgetsInSyncFilter',
      label: 'Prenamjena usklađena',
      type: 'select',
      multiple: false,
      options: [
        { label: 'Da', value: true },
        { label: 'Ne', value: false }
      ],
      placeholder: 'Odaberite'
    });
    return this;
  }

  reallocationBudgetsApproved(): ProjectsFilterBuilder {
    this.fields.push({
      name: 'areReallocationBudgetsApprovedFilter',
      label: 'Prenamjena odobrena',
      type: 'select',
      multiple: false,
      options: [
        { label: 'Da', value: true },
        { label: 'Ne', value: false }
      ],
      placeholder: 'Odaberite'
    });
    return this;
  }

  hasReallocation(): ProjectsFilterBuilder {
    this.fields.push({
      name: 'hasReallocationFilter',
      label: 'Ima prenamjenu',
      type: 'select',
      multiple: false,
      options: [
        { label: 'Da', value: true },
        { label: 'Ne', value: false }
      ],
      placeholder: 'Odaberite'
    });
    return this;
  }

  hasContract() : ProjectsFilterBuilder {
    this.fields.push({
      name: 'contractCreatedFilter',
      label: 'Ugovor kreiran',
      type: 'select',
      multiple: false,
      options: [
        { label: 'Da', value: true },
        { label: 'Ne', value: false }
      ],
      placeholder: 'Odaberite'
    });
    return this;
  }

   reportsApproved(): ProjectsFilterBuilder {
    this.fields.push({
      name: 'reportsApprovedFilter',
      label: 'Izvještaji odobreni',
      type: 'select',
      multiple: false,
      options: [
        { label: 'Da', value: true },
        { label: 'Ne', value: false }
      ],
      placeholder: 'Odaberite'
    });
    return this;
   }

   hasRefundItems(): ProjectsFilterBuilder {
      this.fields.push({
          name: 'hasRefundItemsFilter',
          label: 'Ima stavke povrata',
          type: 'select',
          multiple: false,
          options: [
              { label: 'Da', value: true },
              { label: 'Ne', value: false }
          ],
          placeholder: 'Odaberite'
      });
      return this;
  }

   hasRefundDecision(): ProjectsFilterBuilder {
      this.fields.push({
          name: 'refundCreatedFilter',
          label: 'Odluka o povratu kreirana',
          type: 'select',
          multiple: false,
          options: [
              { label: 'Da', value: true },
              { label: 'Ne', value: false }
          ],
          placeholder: 'Odaberite'
      });
      return this;
  }


  reset(): ProjectsFilterBuilder {
    this.fields = [];
    return this;
  }

  build(): FilterFieldConfig[] {
    return this.fields;
  }
}
